import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import '@/utils/statistics';
import App from '@/pages/index';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
